














import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Prop, Watch } from "vue-property-decorator";
@Component({
})
export default class DropDownComponent extends Vue {
    @Prop() items;
    @Prop() lable;
    @Prop() modelKey;
    @Prop() disabled;
    @Prop() data;
    @Prop() context;
    @Prop() rules;
    componentData: any;
    change()
    {
      this.data[this.modelKey]=this.componentData;
      this.$emit("update",{type:this.lable,value:this.componentData,modelKey:this.modelKey})
    }
    @Watch("data")
    onDataChange(value)
    {
      if(this.context=='update')
      {
      this.componentData=this.data[this.modelKey]
      }
    }
}
